import { jsx as _jsx } from "react/jsx-runtime";
import { MagnifyingGlassIcon } from '../icons/MagnifyingGlassIcon';
export function SearchButton({ handleClick, className }) {
    return (_jsx("button", Object.assign({ className: className, onClick: handleClick, "aria-label": 'Submit Search' }, { children: _jsx(MagnifyingGlassIcon, {}, void 0) }), void 0));
}
//# sourceMappingURL=SearchButton.js.map